import React from 'react'
import PropTypes from 'prop-types'

/**
* Adds inline style tags to add the ability for component specific themes.
*/
class ThemeOverride extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    if (!this.props.textColor && !this.props.backgroundColor && !this.props.choices) {
      return false
    }

    const textColor = this.props.textColor ? `#${this.props.textColor}` : ''


    let backgroundColor = this.props.backgroundColor ? `#${this.props.backgroundColor}` : ''


    const beforeBackgroundColor = (this.props.values && this.props.values.beforeBackground) ? this.props.values.beforeBackground : backgroundColor

    if (this.props.values && this.props.values.backgroundColor) {
      backgroundColor = this.props.values.backgroundColor
    }

    // Some day the `selector` won't be needed once `scoped` `<style>` elements are supported.
    // But that day won't be any time soon.
    // @see https://www.w3schools.com/tags/att_style_scoped.asp
    const styles = []

    // Text Color Override
    if (textColor && this.props.choices.textColor) {
      styles.push(`${this.props.selector}.can-override-text, ${this.props.selector} .can-override-text {color: ${textColor};}`)
    }

    // Background Color
    if (backgroundColor && this.props.choices.backgroundColor) {
      styles.push(`${this.props.selector}.can-override-background-color, ${this.props.selector} .can-override-background-color {background-color: ${backgroundColor};}`)
    }

    // Background Image
    if (this.props.choices.backgroundImage && this.props.values.backgroundImage) {
      styles.push(`${this.props.selector}.can-override-background-image, ${this.props.selector} .can-override-background-image {background-image: url(${this.props.values.backgroundImage});}`)
    }

    // :before Background Color
    if (backgroundColor && this.props.choices.beforeBackground) {
      styles.push(`${this.props.selector}.can-override-before-background:before, ${this.props.selector} .can-override-before-background:before {background-color: ${beforeBackgroundColor};}`)
    }

    // :after Background Color
    if (backgroundColor && this.props.choices.afterBackground) {
      styles.push(`${this.props.selector}.can-override-after-background:after, ${this.props.selector} .can-override-after-background:after {background-color: ${backgroundColor};}`)
    }

    // :scrollbar Background Color
    if (backgroundColor && this.props.choices.scrollbarColor) {
      styles.push(`${this.props.selector}.can-override-scrollbar::-webkit-scrollbar-thumb, ${this.props.selector} .can-override-scrollbar::-webkit-scrollbar-thumb {background-color: ${backgroundColor};}`)
    }

    return (
      <style>
        { styles.join(' ') }
      </style>
    )
  }
}

ThemeOverride.defaultProps = {
  selector: '',
  textColor: '',
  backgroundColor: '',
  choices: {
    textColor: true,
    beforeBackground: true,
    afterBackground: true,
    scrollbarColor: true,
  },
}

ThemeOverride.propTypes = {
  selector: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  choices: PropTypes.shape({
    textColor: PropTypes.bool,
    beforeBackground: PropTypes.bool,
    afterBackground: PropTypes.bool,
    scrollbarColor: PropTypes.bool,
    backgroundColor: PropTypes.bool,
  }),
  values: PropTypes.shape({
    beforeBackground: PropTypes.string,
    backgroundCour: PropTypes.string,
    backgroundImage: PropTypes.string,
  }),
}

export default ThemeOverride
